<template>
  <div class="advantage">
    <Header @navbarClick="navbarClick"></Header>
    <Login></Login>
    <!-- <div class="advantage-bg"></div> -->
    <img class="banner" src="../assets/images/advantage/lancheng_bg.png" alt="">
    <div :class="{navbar:true,fixedNavbar: isfixTab}" id="navbar">
      <div class="navbarList">
        <div :class="['navbar-list-item',navbarId === index ? 'active' : '']" v-for="(item,index) in navbarList" :key="index" @click="navbarClick(index)">{{item.title}}</div>
      </div>
    </div>
    <div class="success-case" :style="isfixTabCss && isfixTab ? 'padding-top:90px' : 'padding-top:56px'" ref="successCase">
      <div class="success-title">成功案例</div>
      <div class="success-enTitle">Success Case</div>
      <div class="case-category-list">
        <div class="case-category-item" v-for="(item,index) in caseCategoryList" :key="index">
          <div class="case-category-item-wrapper">
            <div class="case-category-left">
              <img class="case-icon" :src="item.icon" alt="">
            </div>
            <div class="case-category-right">
              <div class="case-title">{{item.title}}</div>
              <div class="case-intro">{{item.intro}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="market-advantage" :style="isfixTabCss && isfixTab ? 'padding-top:90px' : 'padding-top:56px'" ref="marketAdvantage">
      <div class="market-advantage-title">市场优势 - 大规模的数据覆盖</div>
      <div class="market-advantage-enTitle">Market Advantage Large-scale Data Coverage</div>
      <div class="market-advantage-list">
        <div class="market-advantage-item industry1">
          <div class="order"></div>
          <div class="icon"></div>
          <div class="market-title">行业垂直</div>
          <div class="market-intro">精耕地产行业15年多、合作各细分行业头部企业</div>
        </div>
        <div class="market-advantage-item industry2">
          <div class="order"></div>
          <div class="icon"></div>
          <div class="market-title">行业领先</div>
          <div class="market-intro">楼盘数据&技术</div>
        </div>
        <div class="market-advantage-item industry3">
          <div class="order"></div>
          <div class="icon"></div>
          <div class="market-title">海量数据</div>
          <div class="market-intro">房地产物理数据&挂牌、成交案例数据</div>
        </div>
      </div>
    </div>
    <div class="service-advantage" :style="isfixTabCss && isfixTab ? 'padding-top:90px' : 'padding-top:56px'" ref="serviceAdvantage">
      <div class="service-advantage-title">服务优势</div>
      <div class="service-advantage-enTitle">Service Advantage</div>
      <div class="service-advantage-list">
        <div class="service-advantage-item" v-for="(item,index) in serviceAdvantageList" :key="index">
          <div class="service-title-bg">
            <img class="service-bg" :src="item.titleBg" alt="">
            <div class="service-title">{{item.title}}</div>
          </div>
          <img class="service-icon" :src="item.icon" alt="">
          <div class="service-text">{{item.text}}</div>
        </div>
      </div>
      <div class="info">数据整合了采集自上海统计局、国土资源局、上海房地局等权威机构的公开数据，合作伙伴共享数据和专业团队市调收集数据， 并由专业采编人员实时更新维护、产品及技术团队持续迭代</div>
    </div>
    
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Login from "@/components/Login.vue";
export default {
  name: "advantage",
  components: {
    Header,
    Footer,
    Login
  },
  data() {
    return {
      isfixTab: false,
      navbarId: 0,
      isfixTabCss: false,
      navbarList: [
        {
          title: "成功案例"
        },
        {
          title: "市场优势"
        },
        {
          title: "服务优势"
        }
      ],
      caseCategoryList: [
        {
          icon: require("../assets/images/advantage/advantage_icon0.png"),
          title: "房产数据案例",
          intro:
            "与链家地产、中原地产、我爱我家不动产等房地产头部经纪机构合作二手房案例，周月级监测二手房地产交易市场"
        },
        {
          icon: require("../assets/images/advantage/advantage_icon2.png"),
          title: "楼盘库开放平台与房产数据案例",
          intro:
            "在太平洋房屋重建房客源管理系统搭建过程中，为太屋房客源管理系统、太屋外网提供了楼盘字典基础数据。提供基础数据维护服务，并结合澜城数据成交案例数据，协助其实现了企业数字化管理"
        },
        {
          icon: require("../assets/images/advantage/advantage_icon1.png"),
          title: "估价系统",
          intro:
            "科东估价与银行抵押贷款业务中， 从贷前预估到贷后批量复估，向电子化估价发展；澜城数据结合楼盘架构、案例数据，运用市场比较法模型，实现一房一价估价，为其开发科东估价系统"
        }
      ],
      serviceAdvantageList: [
        {
          titleBg: require("../assets/images/advantage/完善的数据体系bg@2x.png"),
          title: "完善的数据体系",
          icon: require("../assets/images/advantage/完善的数据体系@2x.png"),
          text: "覆盖全上海地产数据95%以上"
        },
        {
          titleBg: require("../assets/images/advantage/基于场景的产品与服务bg@2x.png"),
          title: "基于场景的产品与服务",
          icon: require("../assets/images/advantage/基于场景的产品与服务@2x.png"),
          text: "相关行业不同场景的产品及API，定制开发"
        },
        {
          titleBg: require("../assets/images/advantage/行业的专业咨询bg@2x.png"),
          title: "行业的专业咨询",
          icon: require("../assets/images/advantage/行业的专业咨询@2x.png"),
          text: "提供相关行业的数据咨询及技术支持"
        },
        {
          titleBg: require("../assets/images/advantage/数据更新优势bg@2x.png"),
          title: "数据更新优势",
          icon: require("../assets/images/advantage/数据更新优势@2x.png"),
          text: "楼盘库 - 7*24小时实时更新案例数据 - 周更新、月更新"
        }
      ]
    };
  },
  methods: {
    smoothFun(node) {
      this.$refs[node].scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
      // this.$nextTick(() => {
      //   if(this.$route.path === '/advantage') {
      //     window.location.search = ''
      //   }
      // })
    },
    navbarClick(index) {
      this.navbarId = index;
      // 锚点跳转
      if (index === 0) {
        this.smoothFun("successCase");
      } else if (index === 1) {
        this.smoothFun("marketAdvantage");
      } else if (index === 2) {
        this.smoothFun("serviceAdvantage");
      }
      this.isfixTabCss = true;
    },
    handleTabFix() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var offsetTop = document.querySelector(".success-case").offsetTop;
      scrollTop > offsetTop ? (this.isfixTab = true) : (this.isfixTab = false);

      let successCase = document.querySelector(".success-case").offsetTop - 200;
      let marketAdvantage =
        document.querySelector(".market-advantage").offsetTop - 200;
      let serviceAdvantage =
        document.querySelector(".service-advantage").offsetTop - 200;

      if (scrollTop) {
        if (successCase <= scrollTop && scrollTop < marketAdvantage) {
          this.navbarId = 0;
        } else if (marketAdvantage < scrollTop && scrollTop < serviceAdvantage) {
          this.navbarId = 1;
        } else if (scrollTop > serviceAdvantage) {
          this.navbarId = 2;
        }
      }
    }
  },
  created() {
  },
  mounted() {
    window.addEventListener("scroll", this.handleTabFix, true);
    this.$nextTick(() => {
      if(this.$route.query.name) {
        this.navbarClick(JSON.parse(this.$route.query.name));
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener("scroll", this.handleTabFix, true);
    next();
  }
};
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: auto;
  display: block;
  // height: 240px;
  // background: url("../assets/images/advantage/lancheng_bg.png");
  // background-size: 100% 100%;
}

.navbar {
  width: 100%;
  height: 56px;
  background: #fff;

  &.fixedNavbar {
    height: 56px;
    background: #fff;
    display: flex;
    justify-content: space-around;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 999;
  }
}

.navbarList {
  width: 725px;
  height: 56px;
  margin: 0 auto;

  .navbar-list-item {
    width: 240px;
    height: 56px;
    text-align: center;
    line-height: 56px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #272727;
    float: left;
    position: relative;
    cursor: pointer;

    &:hover {
      color: #3880f4;
    }

    &.active {
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #3880f4;
    }

    &::after {
      content: "";
      width: 1px;
      height: 24px;
      background: rgba(0, 0, 0, 0.06);
      position: absolute;
      top: 16px;
      right: 0;
    }

    &:last-child::after {
      content: "";
      width: 0px;
      height: 24px;
      background: rgba(0, 0, 0, 0.06);
      position: absolute;
      top: 16px;
      right: 0;
    }
  }
}

.success-case {
  width: 100%;
  background: #fff;
  padding-top: 56px;

  .success-title {
    height: 40px;
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    text-align: center;
    color: #272727;
    line-height: 40px;
  }

  .success-enTitle {
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    color: #999999;
    line-height: 22px;
    letter-spacing: 2px;
  }

  .case-category-list {
    width: 1140px;
    margin: 0 auto;
    margin-top: 56px;

    .case-category-item {
      width: 1140px;
      height: 145px;
      background: rgba(56, 128, 244, 0.06);
      border-radius: 2px;
      overflow: hidden;
      margin-bottom: 48px;

      .case-category-item-wrapper {
        margin: 32px 56px 0px 32px;

        .case-category-left {
          width: 64px;
          height: 64px;
          background: #fff;
          border-radius: 50%;
          position: relative;
          float: left;

          .case-icon {
            width: 32px;
            height: 32px;
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }

        .case-category-right {
          width: 956px;
          float: left;
          margin-left: 32px;

          .case-title {
            height: 25px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #272727;
            line-height: 25px;
          }

          .case-intro {
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 20px;
            margin-top: 16px;
          }
        }
      }
    }
  }
}

.market-advantage {
  width: 100%;
  height: 680px;
  background: url("../assets/images/advantage/market_advantage.png");
  background-size: 100% 100%;
  margin-top: 100px;
  overflow: hidden;
  padding-top: 56px;

  .market-advantage-title {
    height: 40px;
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    text-align: center;
    color: #ffffff;
    line-height: 40px;
  }

  .market-advantage-enTitle {
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    line-height: 22px;
    letter-spacing: 2px;
    opacity: 0.45;
  }

  .market-advantage-list {
    width: 1140px;
    height: 369px;
    margin: 0 auto;
    margin-top: 90px;
    display: flex;
    justify-content: space-between;

    .market-advantage-item {
      width: 300px;
      height: 369px;
      background: rgba(0, 0, 0, 0.45);
      border-radius: 2px;
      position: relative;

      &:hover {
        background: rgba(0, 0, 0, 0.65);

        .market-title {
          opacity: 1;
        }
        .market-intro {
          opacity: 0.65;
        }

        &::after {
          content: "";
          width: 160px;
          height: 4px;
          background: #3880f4;
          border-radius: 2px 2px 0px 0px;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }

      &.industry1 .order,
      &.industry2 .order,
      &.industry3 .order {
        width: 58px;
        height: 36px;
        display: block;
        position: absolute;
        top: -18px;
        right: 22px;
      }

      &.industry1 .icon,
      &.industry2 .icon,
      &.industry3 .icon {
        width: 120px;
        height: 120px;
        display: block;
        margin: 0 auto;
        margin-top: 80px;
      }

      &.industry1 .order {
        background: url("../assets/images/advantage/01-默认@2x.png") no-repeat;
        background-size: 100% 100%;
      }

      &.industry1 .icon {
        background: url("../assets/images/advantage/行业垂直-默认@2x.png")
          no-repeat;
        background-size: 100% 100%;
      }

      &.industry2 .order {
        background: url("../assets/images/advantage/02-默认@2x.png") no-repeat;
        background-size: 100% 100%;
      }

      &.industry2 .icon {
        background: url("../assets/images/advantage/行业领先-默认@2x.png")
          no-repeat;
        background-size: 100% 100%;
      }

      &.industry3 .order {
        background: url("../assets/images/advantage/03-默认@2x.png") no-repeat;
        background-size: 100% 100%;
      }

      &.industry3 .icon {
        background: url("../assets/images/advantage/海量数据-默认@2x.png")
          no-repeat;
        background-size: 100% 100%;
      }

      &.industry1:hover .order,
      &.industry2:hover .order,
      &.industry3:hover .order {
        width: 58px;
        height: 36px;
        display: block;
        position: absolute;
        top: -18px;
        right: 22px;
        background: url("../assets/images/advantage/01-hover@2x.png") no-repeat;
        background-size: 100% 100%;
      }

      &.industry1:hover .icon,
      &.industry2:hover .icon,
      &.industry3:hover .icon {
        width: 120px;
        height: 120px;
        display: block;
        margin: 0 auto;
        margin-top: 80px;
        background: url("../assets/images/advantage/icon01-hover@2x.png")
          no-repeat;
        background-size: 100% 100%;
      }

      &.industry2:hover .order {
        background: url("../assets/images/advantage/02-hover@2x.png") no-repeat;
        background-size: 100% 100%;
      }

      &.industry3:hover .order {
        background: url("../assets/images/advantage/03-hover@2x.png") no-repeat;
        background-size: 100% 100%;
      }

      &.industry2:hover .icon {
        background: url("../assets/images/advantage/icon02-hover@2x.png")
          no-repeat;
        background-size: 100% 100%;
      }

      &.industry3:hover .icon {
        background: url("../assets/images/advantage/icon03-hover@2x.png")
          no-repeat;
        background-size: 100% 100%;
      }

      .market-title {
        height: 25px;
        font-size: 18px;
        font-family: PingFangTC-Semibold, PingFangTC;
        font-weight: 600;
        text-align: center;
        color: #ffffff;
        opacity: 0.65;
        line-height: 25px;
        margin-top: 32px;
      }

      .market-intro {
        width: 236px;
        height: 40px;
        margin: 0 auto;
        height: 20px;
        font-size: 14px;
        font-family: PingFangTC-Regular, PingFangTC;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        line-height: 20px;
        margin-top: 16px;
        opacity: 0.45;
      }
    }
  }
}

.service-advantage {
  width: 100%;
  background: #fafbfc;
  overflow: hidden;
  padding-bottom: 100px;
  padding-top: 56px;

  .service-advantage-title {
    height: 40px;
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    text-align: center;
    color: #272727;
    line-height: 40px;
  }

  .service-advantage-enTitle {
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    color: #999999;
    line-height: 22px;
    letter-spacing: 2px;
  }

  .service-advantage-list {
    width: 1140px;
    height: 352px;
    margin: 0 auto;
    margin-top: 56px;
    display: flex;
    justify-content: space-around;

    .service-advantage-item {
      width: 260px;
      height: 352px;
      background: #fff;
      transition: all 0.3s ease;

      &:hover {
        box-shadow: 0px 2px 24px 0px rgba(56, 128, 244, 0.12);
        transform: translateY(-8px);
        transition: all 0.3s ease;
      }

      .service-title-bg {
        width: 260px;
        height: 80px;
        position: relative;

        .service-bg {
          width: 100%;
          height: 80px;
          display: block;
          position: absolute;
          top: 0;
          left: 0;
        }

        .service-title {
          width: 260px;
          height: 80px;
          text-align: center;
          line-height: 80px;
          font-size: 22px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          position: absolute;
          top: 0;
          left: 0;
        }
      }

      .service-icon {
        width: 124px;
        height: 124px;
        display: block;
        margin: 0 auto;
        margin-top: 40px;
      }

      .service-text {
        width: 197px;
        height: 40px;
        margin: 0 auto;
        margin-top: 32px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        text-align: center;
        color: #272727;
        line-height: 20px;
      }
    }
  }

  .info {
    width: 1000px;
    height: 40px;
    margin: 0 auto;
    margin-top: 32px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    text-align: center;
    color: #999999;
    line-height: 20px;
  }
}
</style>


